// Importing necessary components from Material-UI library
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";

export function CustomBackdrop({
  open,
  primaryMessage,
  timer,
  secondaryMessage,
}) {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        // Ensuring the Backdrop is on top of all other elements by setting its zIndex
        zIndex: (theme) =>
          Math.max.apply(Math, Object.values(theme.zIndex)) + 10,
        backdropFilter: "blur(3px)",
      }}
      open={open}
    >
      <Grid
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        sx={{ padding: "20px" }}
      >
        {/* Displaying the message passed as a prop in a Grid item */}
        <Grid item xs={12}>
          <h3>{primaryMessage}</h3>{" "}
        </Grid>
        {/* Displaying a CircularProgress component to indicate loading or processing */}
        <Grid item xs={12}>
          <CircularProgress color="inherit" sx={{ marginLeft: "20px" }} />
        </Grid>
        <Grid item xs={12}>
          <h3 style={{ display: timer ? "flex" : "none" }}>
            {secondaryMessage}
          </h3>
        </Grid>
      </Grid>
    </Backdrop>
  );
}
